<template>
  <div class="container">
    <div>

      <h2>Upload de CSV</h2>
      <hr/>

      <div class="drag-area flex w-full h-screen items-center justify-center text-center" @dragover.prevent="dragOver" @dragleave="dragleave" @drop.prevent @drop="dragFile">
        <input style="display:none;" type="file" id='file-upload' accept=".csv" @change="handleFileUpload( $event )"/>

        <label for="file-upload" class="cursor-pointer text">
          Arraste o arquivo para área azul ou <span class="underline">clique aqui</span> para subir um novo arquivo. 
          Esse arquivo deve ser do tipo csv separado por vírgula.
        </label>

        <label for="file-upload" class="cursor-pointer text">
          Campos do arquivo csv: Nome,Telefone,Empresa,CPF/CNPJ,Grupo
        </label>

        <div class="template-download">
          <a href="/customer_base/csvexemplo" download class="btn-template">
            <i class="fas fa-download"></i> Baixar modelo de CSV
          </a>
        </div>

        <div v-if="file">
          {{ file.name }}
        </div>

        <br>

        <div v-if="saving" class="pb-1">
            <p id="saving"><strong><i class="fas fa-spinner fa-pulse"></i> Atualizando base de contatos. Por favor, aguarde...</strong></p>
        </div>
        <button v-else v-on:click="submitFile()">Enviar</button>
        
      </div>
    </div>
  </div>
</template>

<script>
export default {
    data(){
        return {
            file: '',
            saving: false
        }
    },
    methods: {
        handleFileUpload( event ){
            this.file = event.target.files[0];
        },
        
        dragFile(e){
          document.getElementById('file-upload').files = e.dataTransfer.files;

          this.file = document.getElementById('file-upload').files[0];
          console.log('file', this.file);
          // Clean up
          e.currentTarget.classList.remove('gray');
          e.currentTarget.classList.add('salmon');

        },
        dragOver(event){
          event.currentTarget.classList.add('gray');
          event.currentTarget.classList.remove('salmon');
        },
        dragleave(event){
          // Clean up
          event.currentTarget.classList.remove('gray');
          event.currentTarget.classList.add('salmon');
        },
        submitFile(){
            this.saving = true
            let formData = new FormData();
            let file = document.getElementById('file-upload').files[0];

            if(!this.file){
              Swal.fire({
                type: "warning",
                title: "Arquivo não anexado!",
                text: "Por favor, escolha um arquivo CSV para upload!"
              })
              this.saving = false;
              return;
            }

            formData.append('file', file);

            axios.post( '/customer_base/store',
               formData
            ).then((data) => {
              console.log('>> . >>', data.data);
              Swal.fire(
                'Upload realizado',
                'O arquivo foi adicionado',
                'success'
              )
              this.saving = false;
              document.getElementById('file-upload').value = "";
              this.file = '';
              this.$emit('updateList');
            })
            .catch(function(){
                console.log('FAILURE!!');
            });
      },
    }
}
</script>

<style scoped>
.text{
  padding:1em;
}

.drag-area{

  display: block;
  width: 100%;
  background-color:rgba(28, 133, 154, .05);

}

.gray{
   background-color:rgba(28, 133, 154, 1);
}

.salmon{
  background-color:rgba(28, 133, 154, .05);
}
button{
  border: none;
  background-color: #1c869a;
  width: 49%;
  margin: 1em auto;
  padding: 1em;
  color: white;
  font-family: 'Noto Sans KR', sans-serif;
  text-transform: uppercase;
}

.underline{
  text-decoration: underline;
}

.template-download{
  width: 100%;
  padding: 0.5em 1em;
}

.btn-template{
  display: inline-block;
  background-color: transparent;
  color: #1c869a;
  border: 1px solid #1c869a;
  padding: 0.5em 1.2em;
  font-family: 'Noto Sans KR', sans-serif;
  text-transform: uppercase;
  font-size: 0.85em;
  text-decoration: none;
  transition: background-color 0.2s, color 0.2s;
}

.btn-template:hover{
  background-color: #1c869a;
  color: white;
}
</style>